import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useAddEventMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (formData) => {
      const result = await api.addEvent(formData);
      if (!result.success) {
        throw new Error(result.message || 'Failed to create event');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
